export default __webpack_public_path__ + "static/media/0221.eca55d85.jpg";